                                                                                                                                    //CSS ENTRY POINT
//import '../scss/main.scss';

//=====================================
//jquery
// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
//=====================================
window.$ = window.jQuery = require('jquery');
global.$ = global.jQuery = require('jquery');

//=====================================
// Popper
// require('@popperjs/core');
// require('bootstrap');
// import * as Popper from "@popperjs/core"
//=====================================
window.Popper = require('@popperjs/core');

//=====================================
//Bootstrap
//import * as bootstrap from 'bootstrap';
// // Or import only needed plugins
// import { Tooltip as Tooltip, Toast as Toast, Popover as Popover } from 'bootstrap';
// // Or import just one
// import Alert as Alert from '../node_modules/bootstrap/js/dist/alert';
//=====================================
// require('bootstrap');
// ※Facyboxをインポートすると圧縮版のnpmコンパイルで失敗するため無効
//require('bootstrap');を有効にしたい場合、Fancybox側のimportを無効にして
//CDNをつかう事。

//=====================================
//FANCY BOX
//=====================================
import { Fancybox } from "@fancyapps/ui";
window.Fancybox = Fancybox;

//=====================================
//Gsap
//=====================================
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

//=====================================
//SplitType
//=====================================
const SplitType = require('split-type').default;
window.SplitType = SplitType;
//=====================================
//Swiper
// import Swiper JS
// Swiper, Keyboard, Navigation, Pagination, Controller, History, Autoplay, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Lazy, A11y
//=====================================
const Swiper = require('swiper/bundle').default;
const { Navigation, Pagination, Autoplay, EffectFade } = Swiper;
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
window.Swiper = Swiper;

$(function(){
/////////////////////////////////////
/// SIDEBAR表示トリガー
/////////////////////////////////////
$('.sidebar-toggle').on('click', function() {
  $('body').toggleClass('is-pc-sidemenu');
})
$(document).on("click", function(event) {
  if (!$(event.target).closest("#sidebar").length && !$(event.target).is(".sidebar-toggle")) {
    $('body').removeClass('is-pc-sidemenu');
  }
});
//////////////////////
//SIDE NAV (APP)
//////////////////////
$("#nav-app").on({
  "mouseenter click":function(){
    $(this).addClass("is_slidein");
  },
  "mouseleave":function(){
    $(this).removeClass("is_slidein");
  },
 });

//////////////////////
//スクロース中はSIDE NAVを隠す挙動
//////////////////////
var timeoutId ;
var count = 0 ;
window.addEventListener( "scroll", function () {
  clearTimeout( timeoutId ) ;
  $("#side-slide-navi").removeClass("is_scrollstop");
  timeoutId = setTimeout( function () {
    ++count ;
    if ($(window).scrollTop() >= 200){//headerの高さを超えたら
    $("#side-slide-navi").addClass("is_scrollstop");
    }
  }, 300 ) ;
  } ) ;

//別の要素をクリックで閉じる
$(document).on('click touchend',function(e) {
  if (!$(e.target).closest('#nav-app').length) {
    $("#nav-app").removeClass("is_slidein");
  }
});

//////////////////////
//SP BUGER MENU
//////////////////////
$('#global_burgermenu > button').on('click', function() {
  $(this).toggleClass('active');
  if($(this).hasClass('active')){
      $('body').addClass('is-sp-menu').removeClass('is-sp-menu-close');
  }else{
      $('body').removeClass('is-sp-menu').addClass('is-sp-menu-close');
      $('#global-sp-menu').one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function() {
        $('body').removeClass('is-sp-menu-close');
      });
    }
});

//////////////////////
//Scrollアニメーション
//////////////////////
  // URLのハッシュを評価してスクロールアニメーションを実行
  if (window.location.hash) {
    var target = $(window.location.hash);
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top - 65
      }, 1000);
    }
  }
   // #で始まるアンカーリンクがクリックされたときに実行される処理
   $('a[href^="#"]').on('click', function(e) {
    e.preventDefault();
    var target = $(this).attr('href');
    var position = $(target).offset().top;
    $('html, body').animate({ scrollTop: position }, 500);
  });

/* ==================
SCROLL HEADER HEIGHT
===================== */
  var headerH = $("#header").outerHeight(true);//headerの高さを取得    
  function FixedAnime() {
    var scroll = $(window).scrollTop();
    if (scroll >= headerH){//headerの高さを超えたら
          $('body').addClass('is_scroll');
    }else{
          $('#body').removeClass('is_scroll');
    }    
  }
  
  // 画面をスクロールをしたら動かしたい場合の記述
  $(window).scroll(function () {
    FixedAnime();//スクロール途中からヘッダーの高さを変化させる関数を呼ぶ
  });
  
  // ページが読み込まれたらすぐに動かしたい場合の記述
  $(window).on('load', function () {
    FixedAnime();//スクロール途中からヘッダーの高さを変化させる関数を呼ぶ
  });



/* ==================
FANCYBOX
===================== */
  Fancybox.bind('[data-fancybox]', {
    hideScrollbar: false,
    // compact: false,
    // idle: false,
    // animated: false,
    // showClass: false,
    // hideClass: false,
    // dragToClose: false,
    // contentClick: false,
    Toolbar: {
    display: {
    left: [],
    middle: ['infobar'],
    right: ['close'],
    },
    },
    Thumbs: {
    type: 'classic',
    },
    });


//////////////////////////////////
  /*右から移動*/
  gsap.utils.toArray('.am-x-r').forEach( (elm, index) => {
    gsap.from(elm,
      { x: 100,
        autoAlpha: 0 ,
        duration:1.5,
        opacity: 0,
        ease: "power2.out",
       scrollTrigger: {
        trigger: elm,
        start: 'top bottom', 
        end: 'bottom bottom',
        scrub: 1,
        // markers: true
        },
      });
  });
  
    
    /*左から移動*/
  gsap.utils.toArray('.am-x-l').forEach( (elm, index) => {
    gsap.from(elm,
      { x: -100,
        autoAlpha: 0 ,
        duration:1.5,
        opacity: 1,
        ease: "power2.out",
       stagger: 1.02,
       scrollTrigger: {
        trigger: elm,
        start: 'top bottom', 
        end: 'bottom bottom',
        scrub: 1,
        // markers: true
        },
      });
  });
    
    /*上から移動*/
  gsap.utils.toArray('.am-y-t').forEach( (elm, index) => {
    gsap.from(elm,
      { y: -100,
        autoAlpha: 0 ,
       duration:1.5,
        opacity: 1,
        ease: "power2.out",
        stagger:{
          from: "start", //左から
          amount: 0.8 // 0.8秒おき
        },
        scrollTrigger: {
          trigger: elm,
          start: 'top bottom', 
          end: 'bottom bottom',
          scrub: 1,
          // markers: true
          },
      });
  });
    /*下から移動*/
  gsap.utils.toArray('.am-y-b').forEach( (elm, index) => {
    gsap.from(elm,
     { y: 100,
        autoAlpha: 0 ,
       duration:1.5,
        opacity: 1,
        ease: "power2.out",
        stagger:{
          each:.5,
          ease: "power4.out",
          from: "start", //左から
          amount: 3.8 // 0.8秒おき
        },
        scrollTrigger: {
          trigger: elm,
          start: 'top bottom', 
          end: 'bottom bottom',
          scrub: 1,
          // markers: true
          },
      });
    });
  
  
  /*中央からスケール*/
  gsap.utils.toArray('.am-s-0').forEach( (elm, index) => {
  gsap.from(elm,
    { scaleX: .5,
      duration:1.5,
      opacity: 0,
      ease: "power2.out",
      scrollTrigger: {
        trigger: elm,
        start: 'top bottom', 
        end: 'bottom bottom',
        scrub: 1,
        // markers: true
        },
    });
  });
  

/////////////////////////////////
    /*画像パララックス*/
/////////////////////////////////
//TOP PAGE MV
    gsap.from("#an-tit1", {
      x:500,
      opacity: 0,
      duration: 1,
      rotation: 80,
      ease: "power2.out",
    });
    gsap.from("#an-tit2", {
      x:500,
      rotation: 80,
      opacity: 0,
      duration: 1,
      delay: .2,
      ease: "power2.out",
    });
    gsap.from("#an-icn img", {
      y:20,
      scale: 0.1,
      opacity: 0,
      duration: .6,
      delay: 1,
      stagger: 0.1,
      ease: "power2.out",
    });


    gsap.from("#an-stit", {
        x:-1000,
        y: -1000,
      rotation: -240,
      opacity: 0,
      delay: 2,
      duration: 1,
      scale:10,
      ease: "power2.out",
    });
    gsap.from("#char2 .char", {
      y:-500,
      x:-500,
      scale:0,
      rotation: 180,
      stagger: .05,
      opacity: 0,
      delay: 2.2,
      duration: 0.6,
      ease: "power2.out",
    });
});